<template>
  <div class="d-flex flex-column gap-1 flex-sm-row flex-wrap gap-sm-2 gap-md-3">
    <div
      v-for="(stat, index) in stats"
      :key="index"
      class="d-flex gap-1 align-center flex-sm-row-reverse"
    >
      <span class="">{{ stat.text }}</span>
      <v-spacer />
      <pill-status width="32px" :status="stat.value" :color="stat.color" />
    </div>
  </div>
</template>

<script>
  import PillStatus from './PillStatus.vue';

  export default {
    name: 'MaterialStatusHelper',
    components: { PillStatus },
    data: () => ({
      stats: [
        { value: 'AVAILABLE', text: 'Con existencia 100%' },
        { value: 'PARTIAL', text: 'Con existencias parciales' },
        { value: 'UNAVAILABLE', text: 'No hay existencias' },
      ],
    }),
  };
</script>
